import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import SwiperCore from 'swiper';
import cpsImg from '../assets/partnerships/cps.png';
import brandImg from '../assets/partnerships/brand.png';
import affiliateImg from '../assets/partnerships/affiliate.png';


// 引入 Swiper 样式
import 'swiper/css';
import 'swiper/css/effect-coverflow';
// 引入你自定义的样式
import '../css/Card.css';

// 安装并启用 coverflow 效果模块
SwiperCore.use([EffectCoverflow]);

export const Card = () => {
  return (
    <section>
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2,
          slideShadows: true,
        }}
      >
        <SwiperSlide>
          <div className="testimonialBox">
            <img src={cpsImg} alt="quote" className="quote" />
            <div className="content">
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusamus natus laboriosam ullam laudantium alias quibusdam omnis, ab eius corrupti dolorem nam a voluptatem consequuntur maxime rerum sed dicta laborum delectus?
              </p>
              <div className="details">
                <div className="imgBx">
                  <img src="./img/user1.png" alt="User 1" />
                </div>
                <h3>
                  Call me Phoenix
                  <br />
                  <span>Creative Designer</span>
                </h3>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonialBox">
            <img src={cpsImg} alt="quote" className="quote" />
            <div className="content">
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusamus natus laboriosam ullam laudantium alias quibusdam omnis, ab eius corrupti dolorem nam a voluptatem consequuntur maxime rerum sed dicta laborum delectus?
              </p>
              <div className="details">
                <div className="imgBx">
                  <img src="./img/user2.png" alt="User 2" />
                </div>
                <h3>
                  Call me Phoenix
                  <br />
                  <span>Creative Designer</span>
                </h3>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonialBox">
            <img src={cpsImg} alt="quote" className="quote" />
            <div className="content">
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Accusamus natus laboriosam ullam laudantium alias quibusdam omnis, ab eius corrupti dolorem nam a voluptatem consequuntur maxime rerum sed dicta laborum delectus?
              </p>
              <div className="details">
                <div className="imgBx">
                  <img src="./img/user3.png" alt="User 3" />
                </div>
                <h3>
                  Call me Phoenix
                  <br />
                  <span>Creative Designer</span>
                </h3>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      
      <div className="section-divider"></div>
    </section>

  );
};


